<template>
  <v-dialog v-model="isOpen" persistent max-width="600px">
    <v-card>
      <v-card-title v-html="dialogTitle"></v-card-title>
      <v-divider class="mx-4"></v-divider>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <br>
            <p v-html="dialogDescription"></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {DEFAULT_USER_INACTIVITY_TIME, USER_INACTIVITY_LOGOUT_TIME } from '../../olsStateManagement/helpers/constants';
import {authService} from '../../olsStateManagement/services/auth.service'

export default {
    name: "AutoSignOut",

    props: {
      title: {
        type: String,
        default: "",
      },
      description: {
        type: String,
        default: ""
      },
      userInactivityTime: {
        type: Number,
        default: DEFAULT_USER_INACTIVITY_TIME
      }
    },

    computed: {
      dialogTitle: {
        get() {
          return this.title;
        }
      },
      dialogDescription: {
        get() {
          return this.description;
        }
      },
      dialogUserInactivityTime: {
        get() {
          return this.userInactivityTime;
        }
      },
    },

    data() {
      return {
        isOpen: false,

        events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress'],

        warningTimer: null,
      }
    },

    mounted() {
      this.events.forEach((event) => {
        window.addEventListener(event, this.resetTimer);
      }, this);

      this.setTimers();
    },

    methods: {
      resetTimer() {
        clearTimeout(this.warningTimer);
        this.setTimers();
      },

      setTimers() {
        this.warningTimer = setTimeout(this.warningMessage, this.dialogUserInactivityTime * 1000);
        // this.isOpen = false;
      },

      warningMessage() {
        this.isOpen = true;
        setTimeout(() => {
          this.logout()
        }, USER_INACTIVITY_LOGOUT_TIME * 1000);
      },

      logout() {
        authService.logout();
      }
    }

  }
</script>
